// extracted by mini-css-extract-plugin
export default {"content":"steps_content__t9OO3","container":"steps_container__ZkhRX","stepsContainer":"steps_stepsContainer__rOmVf"};